module.exports = __webpack_public_path__ + "static/media/icn_share.e09adc17.svg";